// Module
var code = " <span class=\"below-reserve-badge\" translate=\"ITEM_RESERVE_NOT_MET\" translate-values=\"{reverve_amount: $ctrl.getReserveAmount()}\" ng-if=\"$ctrl.shouldShowBelowReserve()\" ng-style=\"$ctrl.getBelowReserveStyle()\"> </span> ";
// Exports
export default code;